//import moment from 'moment-mini';
import moment from "moment-timezone";
import "moment/min/locales";
import { Language } from "./Languages";

class DateHelper {
  static get timeZone(): string {
    const timeZone = moment.tz.guess();
    return timeZone;
  }

  static GetTimeDiff = (lastUpdate: string): string => {
    const now = moment(new Date());
    const local = moment.utc(lastUpdate).local();
    const diffTime = moment(now).diff(local);
    const duration = moment.duration(diffTime, "milliseconds");
    const fromHours = Math.floor(duration.asHours());
    const fromMinutes = Math.floor(duration.asMinutes() - fromHours * 60);
    const fromSeconds = Math.floor(
      duration.asSeconds() - fromMinutes * 60 - fromHours * 60
    );
    return (
      ("0" + fromHours).slice(-2) +
      ":" +
      ("0" + fromMinutes).slice(-2) +
      ":" +
      ("0" + fromSeconds).slice(-2)
    );
  };

  static GetDateAndTime = (dateTime: string, timeFormat = "LTS"): any => {
    const local = moment.utc(dateTime).local();

    return { time: local.format(timeFormat), date: local.format("L") };
  };

  static GetDayMonthTime = (
    tickItem: number | string,
    lang: Language
  ): string => {
    if (!tickItem) return "";
    const res = moment(tickItem).format("L LTS");
    const yearPart = moment(tickItem).format("YYYY");

    const isBefore = lang.code === "ja" || lang.code.indexOf("zh") !== -1;
    const LocalSeparator =
      res.indexOf("/") > -1 ? "/" : res.indexOf("-") > -1 ? "-" : ".";
    return res.replace(
      !isBefore ? LocalSeparator + yearPart : yearPart + LocalSeparator,
      ""
    );
  };
  static vitalsForCSVTime = (tickItem: number | string): string => {
    if (!tickItem) return "";
    return moment(tickItem).format("L LTS");
  };
  static GetDayMonth = (tickItem: number | string, lang: Language): string => {
    if (!tickItem) return "";
    const res = moment(moment.utc(tickItem).toISOString()).format("L ");
    const yearPart = moment(tickItem).format("YYYY");

    const isBefore = lang.code === "ja" || lang.code.indexOf("zh") !== -1;
    const LocalSeparator =
      res.indexOf("/") > -1 ? "/" : res.indexOf("-") > -1 ? "-" : ".";
    return res.replace(
      !isBefore ? LocalSeparator + yearPart : yearPart + LocalSeparator,
      ""
    );
  };

  static GetHandledAfter = (duration: number): string => {
    return moment
      .utc(duration * 1000)
      .format("HH:mm:ss")
      .toLowerCase();
  };

  static GetHandledAfterDate = (dateTime: string, duration: number): any => {
    const local = moment.utc(dateTime).local();
    local.add(duration, "seconds");
    return { time: local.format("LTS").toLowerCase(), date: local.format("L") };
  };

  static GetDataFromTimestamp = (value: number): string => {
    const local = moment.utc(value).local();
    return local.format("L") + " " + local.format("LTS");
  };

  static LocalTime = (date: string, format: string): string => {
    return moment.utc(date).local().format(format).toLowerCase();
  };

  static WithDateIfNotToday = (date: string, format = "LT"): string => {
    const now = moment();
    if (now.get("D") !== moment.utc(date).local().get("D"))
      return moment
        .utc(date)
        .local()
        .format("L, " + format)
        .toLowerCase();
    return moment.utc(date).local().format(format).toLowerCase();
  };
  static GlobalTime = (date: string, format: string): string => {
    return moment(date).format(format).toLowerCase();
  };

  static LocalTimePartial = (time: string): string => {
    let now = new Date().toISOString();

    now = now.slice(0, now.indexOf("T")) + " " + time;

    return moment(now).format("LT").toLowerCase();
  };

  static toUtcTimePartial = (timeIn: string): string => {
    let now = moment().toISOString();
    let time = timeIn;

    if (time.indexOf("오전") !== -1)
      time = time.replace("오전 ", "").concat(" am");
    else if (time.indexOf("오후") !== -1)
      time = time.replace("오후 ", "").concat(" pm");

    now = now.slice(0, now.indexOf("T")) + " " + time;

    return moment(now).format("HH:mm");
  };

  static fromUtcTimePartial = (timeIn: string): string => {
    let now = moment().toISOString();
    let time = timeIn;
    if (time.indexOf("오전") !== -1)
      time = time.replace("오전 ", "").concat(" am");
    else if (time.indexOf("오후") !== -1)
      time = time.replace("오후 ", "").concat(" pm");
    now = now.slice(0, now.indexOf("T")) + " " + time;
    return moment(moment(now).toDate()).local().format("LT").toLowerCase();
  };

  static LocalTimePeriod = (time1: string, time2: string): string => {
    return (
      moment("1970-01-01 " + time1)
        .format("LT")
        .toLowerCase() +
      " - " +
      moment("1970-01-01 " + time2)
        .format("LT")
        .toLowerCase()
    );
  };
}
export { DateHelper };
